module.exports = __webpack_public_path__ + "media/images/placeholder-sequences-1d6462e5.png";